import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { BoardModule } from '../board/board.module';
import { SharedModule } from '@shared';

@NgModule({
  imports: [CommonModule, BoardModule, SharedModule, DashboardComponent],
  exports: [DashboardComponent],
})
export class DashboardModule {}
